
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import React, { useState, useEffect, useRef } from 'react';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import Toast from '../../Shared/Toast/Toast';
import { FloatLabel } from 'primereact/floatlabel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ColorPicker } from 'primereact/colorpicker';
import { MultiSelect } from 'primereact/multiselect';
import { Checkbox } from 'primereact/checkbox';
import { useCatchResponse } from '../../../utils/useCatchResponse';

const AddGradeMasterDialog = (props) => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const [gradeTemplateName, setGradeTemplateName] = useState('');
    const [gradeTemplateNameErrText, setGradeTemplateNameErrText] = useState('');
    const [gradeTemplateNameErr, setGradeTemplateNameErr] = useState(false);
    const [className, setClassName] = useState([]);
    const [classNameErrText, setClassNameErrText] = useState('');
    const [classNameErr, setClassNameErr] = useState(false);
    const [gradeTemplateValues, setGradeTemplateValues] = useState([]);
    const [classList, setClassList] = useState([]);
    const [isCoScholastic, setIsCoScholastic] = useState(false);


    const submitButtonRef = useRef(null);
    const gradeTemplateNameRef = useRef(null);
    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);

        // Ensure focus after modal renders
        setTimeout(() => {
            gradeTemplateNameRef.current?.focus();
        }, 100);
    }, []);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        GetClassList(loginData?._id);
        let values = [
            {
                'GradeName': '',
                'PercentageFrom': '',
                'PercentageTo': '',
                'HexCode': '',
                'Remark': ''
            }
        ]
        if (props.ID) {
            setGradeTemplateName(props?.masterData?.GradeTemplateName);
            setClassName(props?.masterData?.ClassId ? props?.masterData?.ClassId.split(',') : []);
            let valuesData = props?.masterData?.GradeTemplateValues ? props?.masterData?.GradeTemplateValues : values;
            setGradeTemplateValues(valuesData)
            setIsCoScholastic(props?.masterData?.IsCoScholastic);
        } else {
            setGradeTemplateValues(values);
        }
    }, []);

    const onCancel = () => {
        props.onCancel();
        setGradeTemplateName('');
        setGradeTemplateValues([]);
    }

    const GetClassList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getClassList, data).then(async response => {
                let res = response;
                if (res.success) {
                    const formatedData = Array.from(
                        new Map(
                            res?.data?.filter(x => x?.Status === 'Active')?.map((x) => [
                                x?.ClassId,
                                {
                                    ...x,
                                    value: x?.ClassId,
                                    label: `${x?.ClassName}-${x?.MediumName}-${x?.Board}`
                                }
                            ])
                        ).values());
                    setClassList(formatedData);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const validate = () => {
        let formIsValid = true;
        if (CommonConfig.isEmpty(gradeTemplateName)) {
            formIsValid = false;
            setGradeTemplateNameErr(true);
            setGradeTemplateNameErrText("Grade Template Name is required");
        } else {
            setGradeTemplateNameErr(false);
            setGradeTemplateNameErrText("");
        }
        if (className.length === 0) {
            formIsValid = false;
            setClassNameErr(true);
            setClassNameErrText("Select atleast one class");
        } else {
            setClassNameErr(false);
            setClassNameErrText("");
        }
        return formIsValid;
    };

    const AddGradeMaster = async (e) => {
        if (validate(e)) {
            try {
                Loader.show();
                const gradeData = gradeTemplateValues ? gradeTemplateValues.filter(x => !CommonConfig.isEmpty(x?.GradeName))?.map(y => ({
                    ...y,
                    PercentageFrom: isCoScholastic ? '' : y?.PercentageFrom,
                    PercentageTo: isCoScholastic ? '' : y?.PercentageTo,
                })) : [];
                let data = {
                    id: props?.ID,
                    GradeTemplateName: gradeTemplateName,
                    ClassId: className.length > 1 ? className.join(',') : className[0],
                    IsCoScholastic: isCoScholastic,
                    GradeTemplateValues: gradeData,
                    CreatedBy: securityUserID,
                };
                await api
                    .post(APIConstant.path.AddUpdateGradeMaster, data)
                    .then((response) => {
                        let res = response;
                        if (res.success) {
                            Toast.success({ message: res.message });
                            Loader.hide();
                            onCancel();
                        } else {
                            Toast.error({ message: res.message });
                            Loader.hide();
                            // onCancel();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        Loader.hide();
                        // onCancel();
                    });
            } catch (err) {
                console.log(err);
                Loader.hide();
                onCancel();
                catchResponse(err);
            }
        }
    };

    const handleChange = (e, type) => {
        const value = e.target.value;
        const alphanumericValue = value.replace(/[^a-zA-Z0-9\s!@#$%^&*./+-\u0A80-\u0AFF\u0900-\u097F\s]/g, '');
        setGradeTemplateName(alphanumericValue);
    };

    const gradeNameBodyTemplate = (rowData, { rowIndex }) => {
        return (
            <div className='custom-inputs'>
                <InputText
                    className="p-mt-2 p-w-50"
                    id={`gradeName-${rowIndex}`}
                    type="text"
                    maxLength={20}
                    placeholder="Grade Name"
                    value={rowData?.GradeName}
                    onChange={(e) => handleTemplateValuesChange(rowIndex, 'GradeName', e.target.value)}
                />
            </div>
        )
    };

    const percentageFromBodyTemplate = (rowData, { rowIndex }) => {
        return (
            <div className='p-d-flex p-ai-center custom-inputs'>
                <InputText
                    className="p-mt-2 p-w-20 p-mr-2"
                    id={`percentageFrom-${rowIndex}`}
                    type="text"
                    maxLength={6}
                    placeholder="Percentage From"
                    value={rowData?.PercentageFrom}
                    onChange={(e) => handleTemplateValuesChange(rowIndex, 'PercentageFrom', e.target.value)}
                />
                <InputText
                    className="p-mt-2 p-w-20"
                    id={`percentageTo-${rowIndex}`}
                    type="text"
                    maxLength={6}
                    placeholder="Percentage To"
                    value={rowData?.PercentageTo}
                    onChange={(e) => handleTemplateValuesChange(rowIndex, 'PercentageTo', e.target.value)}
                />
            </div>
        )
    };

    const hexCodeBodyTemplate = (rowData, { rowIndex }) => {
        return (
            <div className='p-d-flex p-ai-baseline custom-inputs'>
                <ColorPicker className='e-color-picker'
                    onChange={(e) => handleColorChange(rowIndex, 'HexCode', e.value)}
                    value={rowData?.HexCode.replace("#", "")}
                />
                <InputText
                    className="p-mt-2 p-w-80 p-ml-2"
                    id={`hexCode-${rowIndex}`}
                    type="text"
                    maxLength={8}
                    placeholder="Hex Code"
                    onChange={(e) => handleInputChange(rowIndex, 'HexCode', e.target.value)}
                    value={rowData?.HexCode}
                />
            </div>
        )
    };

    const handleColorChange = (index, key, value) => {
        const updatedTemplateValues = [...gradeTemplateValues];
        updatedTemplateValues[index][key] = value;
        setGradeTemplateValues(updatedTemplateValues);
    };

    const handleInputChange = (index, key, value) => {
        const alphanumericValue = value.replace(/[^a-zA-Z0-9\s]/g, '');
        const updatedTemplateValues = [...gradeTemplateValues];
        updatedTemplateValues[index][key] = alphanumericValue.trim().replace(/\s+/g, ' ');
        setGradeTemplateValues(updatedTemplateValues);
    };

    const remarkBodyTemplate = (rowData, { rowIndex }) => {
        return (
            <div className='custom-inputs'>
                <InputText
                    className="p-mt-2 p-w-80"
                    id={`remark-${rowIndex}`}
                    type="text"
                    maxLength={500}
                    placeholder="Remark"
                    value={rowData?.Remark}
                    onChange={(e) => handleTemplateValuesChange(rowIndex, 'Remark', e.target.value)}
                />
            </div>
        )
    };

    const actionsBodyTemplate = (rowData, { rowIndex }) => (
        <div className="p-d-flex p-jc-start">
            {rowIndex === gradeTemplateValues.length - 1 &&
                <Button
                    icon="pi pi-plus"
                    className="e-sction-btn p-m-0 p-m-2"
                    onClick={() => addTemplateValue()}
                />}
            {(rowIndex !== 0 || gradeTemplateValues.length > 1) &&
                <Button icon="pi pi-trash" className="e-sction-btn p-m-0 p-m-2"
                    onClick={() => removeTemplateValue(rowIndex)}
                />
            }
        </div>
    );

    const addTemplateValue = () => {
        let values = [{
            'GradeName': '',
            'PercentageFrom': '',
            'PercentageTo': '',
            'HexCode': '',
            'Remark': ''
        }];
        setGradeTemplateValues([...gradeTemplateValues, ...values]);
    };

    const removeTemplateValue = (index) => {
        const updatedTemplates = gradeTemplateValues?.filter((_, i) => i !== index);
        setGradeTemplateValues(updatedTemplates);
    };

    const handleTemplateValuesChange = (index, key, value) => {
        const updatedTemplateValues = [...gradeTemplateValues];
        if (key === 'PercentageFrom' || key === 'PercentageTo') {
            const numericValue = value.replace(/[^0-9.]/g, '');
            updatedTemplateValues[index][key] = numericValue;
        } else if (key === 'Remark') {
            // const alphanumericValue = value.replace(/[^a-zA-Z0-9\s!@#$%^&*\u0A80-\u0AFF\u0900-\u097F\s]/g, '');
            // updatedTemplateValues[index][key] = value?.trim().replace(/\s+/g, ' ');
            updatedTemplateValues[index][key] = value;
        } else {
            const alphanumericValue = value.replace(/[^a-zA-Z0-9\s!@#$%^&*\u0A80-\u0AFF\u0900-\u097F\s]/g, '');
            updatedTemplateValues[index][key] = alphanumericValue.trim().replace(/\s+/g, ' ');
        }
        setGradeTemplateValues(updatedTemplateValues);
    };

    return (
        <div className="grade-master-table">
            <div className='p-grid'>
                <div className="p-col-6 p-md-4 custom-inputs">
                    <label htmlFor="gradeTemplateName">Template Name<span style={{ color: "red" }}>*</span></label>
                    <FloatLabel>
                        <InputText
                            ref={gradeTemplateNameRef}
                            className="p-mt-2 p-w-100"
                            id="gradeTemplateName"
                            type="text"
                            maxLength={20}
                            placeholder="Grade Template Name"
                            value={gradeTemplateName}
                            autoFocus={true}
                            onChange={(e) => handleChange(e)}
                        />
                    </FloatLabel>
                    <span className="error-msg" style={{ color: 'red' }}>
                        {gradeTemplateNameErr ? gradeTemplateNameErrText : null}
                    </span>
                </div>
                <div className="p-col-6 p-md-4 custom-inputs">
                    <label htmlFor="className">Class<span style={{ color: "red" }}>*</span></label>
                    <MultiSelect id="className" className='p-w-100 p-mt-2' style={{ height: '42px', paddingBlock: '0px' }} value={className} options={classList}
                        onChange={(e) => setClassName(e.value)} placeholder="Select Class" display="chip" filter
                        showClear optionValue='value' optionLabel='label' />
                    <span className="error-msg" style={{ color: 'red' }}>
                        {classNameErr ? classNameErrText : null}
                    </span>
                </div>
                <div className="p-col-6 p-md-4 p-mt-5 p-pt-3">
                    <Checkbox
                        inputId='isCoScholastic'
                        value={isCoScholastic}
                        onChange={(e) => setIsCoScholastic(e.checked)}
                        checked={isCoScholastic}
                    />
                    <label htmlFor='houseWiseImage' className='p-ml-2'>Co-Scholastic</label>
                </div>
                <div className='e-grade-master-table p-w-100'>
                    <DataTable value={gradeTemplateValues} responsiveLayout="scroll" className="main-table table-td">
                        <Column header="Grade Name" body={gradeNameBodyTemplate} />
                        {!isCoScholastic &&
                            <Column header="Percentage" body={percentageFromBodyTemplate} />}
                        <Column header="Hex Code" body={hexCodeBodyTemplate} style={{ maxWidth: '160px' }} />
                        <Column header="Remark" body={remarkBodyTemplate} onKeyDown={(e) => {
                            if (e.key === 'Tab' && !e.shiftKey) {
                                e.preventDefault();
                                if (submitButtonRef.current) {
                                    submitButtonRef.current.focus();
                                }
                            }
                        }} />
                        <Column header="Actions" body={actionsBodyTemplate} />
                    </DataTable>
                </div>
            </div>
            <div className='dialog-footer p-d-flex p-ai-center p-jc-end p-my-2'>
                <Button className='p-m-0 btn-text-action-secondary p-m-1' onClick={(e) => onCancel()}> Cancel </Button>
                <Button ref={submitButtonRef} className='p-m-0 btn-text-action-primary submit-focus' label="Submit" severity="secondary" raised onClick={(e) => AddGradeMaster()} />
            </div>
        </div>
    );
};

export default AddGradeMasterDialog;
